import { axios } from 'api'

export interface UpdateNetsuiteIdsResponse {
  message: string
  updatedCount: number
  updates: Array<{
    email: string
    oldNetsuiteCustomerId: string
    newNetsuiteCustomerId: string
  }>
  notFoundCount: number
  notFound: string[]
}

export const updateNetsuiteIds =
  async (): Promise<UpdateNetsuiteIdsResponse> => {
    const response = await axios.post(
      '/accounts/update-netsuite-ids',
      {},
      {
        withCredentials: true
      }
    )

    if (response.status !== 200) {
      throw new Error(
        response.data?.error || 'Failed to update NetSuite customer IDs'
      )
    }

    return response.data
  }
